import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { put } from "../../lib/sessionClient";
import { clearLocalStorageSession } from "../../lib/authUtils";

const usePutData = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState("");
  const [successResponse, setSuccessResponse] = useState(null);

  const executePut = async (apiUrl, data) => {
    setLoading(true);
    setFormError("")
    try {
      const response = await put(apiUrl, data);
      setSuccessResponse(response.data);
      setLoading(false);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        clearLocalStorageSession();
        navigate("/login");
      } else {
        setFormError(error.response?.data?.message || error.message);
      }
    } finally {
      setLoading(false);
    }
  };
  return {
    executePut,
    loading,
    formError,
    successResponse,
    setFormError,
    setSuccessResponse,
  };
};

export default usePutData;
